import styled from "styled-components";

export const Title = styled.h1`
    width: 100%;
    font-size: 36px;
    text-align: center;
    color: #ffffff;
    font-weight: bold;
    padding: 86px 0;
    text-transform: uppercase;
    letter-spacing: 6px;
    position: relative;
    overflow: hidden;
    overflow-wrap: break-word;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        bottom: 43px;
        right: 50%;
        transform: translateX(50%);
    }
`